module.exports = __webpack_public_path__ + "static/media/logo-ufscar-fundo-transparente.84831ee0.png";